import React from 'react';
import { Link, TableRow, TableSection } from '@solvhealth/jigsaw-v1';
import { TFunction, withTranslation } from 'react-i18next';
import { useSolvSelector } from '~/reducers';
import { PHOTO_ID_UPLOAD_ORIGIN_GENERIC_RETURN } from '~/core/util/bookingFlowRouting';
import { isClientSide } from '../../../../core/util/system';
import { usePaperworkContextBookingId } from '~/routes/paperwork/PaperworkBookingIdContext';
import { getProfileFromBooking } from '~/core/util/account';

type Props = {
  showEditButton?: boolean;
  t: TFunction<['common', 'paperwork']>;
};

const FinalizePhotoIdCard = (props: Props) => {
  const { showEditButton = true, t } = props;

  const getReturnUrl = () => {
    if (!isClientSide()) return null;
    return window.location.pathname;
  };

  const accountSummary = useSolvSelector((state) => state.account.summary);
  const bookingId = usePaperworkContextBookingId();
  const booking = useSolvSelector((state) => state.pastBookings[bookingId]);
  const userProfile = getProfileFromBooking(accountSummary, booking);
  const photoId = useSolvSelector((state) => state.photoId);

  const getFrontOfIdValue = () => {
    if ((photoId?.front?.id && photoId.front.imageData) || userProfile?.photo_id_front_id) {
      return t('paperwork:finalize.photoId.onFile');
    }
    return t('paperwork:finalize.photoId.none');
  };

  const getBackOfIdValue = () => {
    if ((photoId?.back?.id && photoId.back.imageData) || userProfile?.photo_id_back_id) {
      return t('paperwork:finalize.photoId.onFile');
    }
    return t('paperwork:finalize.photoId.none');
  };

  return (
    <TableSection
      accessory={
        showEditButton && (
          <Link
            href={`/photo-id-upload/${PHOTO_ID_UPLOAD_ORIGIN_GENERIC_RETURN}?to=${getReturnUrl()}`}
          >
            {t('common:edit').toLocaleLowerCase()}
          </Link>
        )
      }
      title={t('paperwork:common.photoId')}
    >
      <TableRow
        title={t('paperwork:standardFields.frontOfId.finalize')}
        value={getFrontOfIdValue()}
      />
      <TableRow
        title={t('paperwork:standardFields.backOfId.finalize')}
        value={getBackOfIdValue()}
      />
    </TableSection>
  );
};

export default withTranslation(['common', 'paperwork'])(FinalizePhotoIdCard);
